<!-- 
  @desc 审批信息列表 --- qss，admin权限右边头部审批信息
  @version version=1.0.0 2019-11-05
  @author yd_yuliping
-->
<template>
  <el-row v-if="approveList" class="approve_msg">
    <el-col class="title_panel approve_list">
      <span class="approve_item">审批通过U系列比赛：3</span>
      <span class="approve_item">审批通过精英训练营：1</span>
      <span class="approve_item">审批通过传统校比赛：0</span>
      <span class="approve_item">审批通过俱乐部比赛：0</span>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    approveList: Object
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.approve_list {
  font-size: 0.875rem;

  .approve_item {
    margin: 0 0.875rem;
  }
  .approve_item:first-child {
    margin-left: 0;
  }
}
</style>
